/** Minimal RFC-style CSV parser (quoted fields, commas, newlines). */
export function parseCsvRows(text: string): string[][] {
  const rows: string[][] = [];
  let row: string[] = [];
  let field = '';
  let inQuotes = false;
  const pushRow = () => {
    if (row.length > 1 || row[0] !== '') {
      rows.push(row);
    }
    row = [];
    field = '';
  };
  for (let i = 0; i < text.length; i++) {
    const c = text[i];
    if (inQuotes) {
      if (c === '"') {
        if (text[i + 1] === '"') {
          field += '"';
          i++;
        } else {
          inQuotes = false;
        }
      } else {
        field += c;
      }
    } else if (c === '"') {
      inQuotes = true;
    } else if (c === ',') {
      row.push(field);
      field = '';
    } else if (c === '\n') {
      row.push(field);
      pushRow();
    } else if (c !== '\r') {
      field += c;
    }
  }
  row.push(field);
  if (row.length > 1 || row[0] !== '') {
    rows.push(row);
  }
  return rows;
}

/** Reads a text file, dropping a leading UTF-8 BOM. */
export function readFileAsText(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = () => {
      let t = String(fr.result ?? '');
      if (t.charCodeAt(0) === 0xfeff) {
        t = t.slice(1);
      }
      resolve(t);
    };
    fr.onerror = () => reject(fr.error ?? new Error('Read failed'));
    fr.readAsText(file);
  });
}
